import React from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import { getTempToken, logout } from "../features/Loginuser";
import Navbarp from "../Components/CommonComponents/Navbarp";
import SideNav from "../Components/CommonComponents/SideNav";
import { useState, useEffect } from "react";
import {
  checkspecial,
  required,
  checkminlenght,
  checkuppercase,
  checknumber,
  checkemail,
  checkmaxlenght,
  checklowercase,
} from "../Common/validation";
import { APPLICATION_ID, AUTH_BASE_URL, BASE_URL } from "../Config/Config";
import DialogModal from "../Components/CommonComponents/DialogModal";
import SmallLoader from "../Components/CommonComponents/SmallLoader";
import Otpmodal from "../Components/CommonComponents/Otpmodal";
function ResetPassword() {
  const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [Errpassword, setErrpassword] = useState("");
  const [errOtp, setErrOtp] = useState("");
  const [cnfpassworderr, setcnfpassworderr] = useState("");
  const [passwordtype, setpasswordtype] = useState("password");
  const [cnfpasswordtype, setcnfpasswordtype] = useState("password");
  const [otp, setOtp] = useState(null);
  const [error, setError] = useState(false);
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [type, setType] = useState("");
  const [loading, setLoading] = useState(false);
  const [otpShow, setOtpShow] = useState(false);
  const tempToken = useSelector(getTempToken);
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(null);
  function handleSubmit(e) {
    e.preventDefault();
    const pasval = validate(password, "password");
    const cnfpasval = validate(password, "confirmpassword");
    if (pasval && cnfpasval) {
      updatepassword(e);
    }
  }

  function updatepassword(e) {
    setLoading(true);
    fetch(AUTH_BASE_URL + "/auth/reset-password", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },

      //make sure to serialize your JSON body
      body: JSON.stringify({
        username: tempToken,
        token: otp,
        password: password,
        confirmPassword: password,
        applicationId: APPLICATION_ID,
      }),
    })
      .then((response) => response.json())
      //Then with the data from the response in JSON...
      .then((data) => {
        if (data.success) {
          setLoading(false);
          e.target.reset();
          setMessage(data.message);
          const seconds = 3;
          setCountdown(seconds);

          const interval = setInterval(() => {
            setCountdown((prev) => {
              if (prev <= 1) {
                clearInterval(interval);
                navigate("/");
                return 0;
              }
              return prev - 1;
            });
          }, 1000);
        } else {
          setLoading(false);
          setErrorMessage(data.error);
        }
      });
  }

  function validate(data, type) {
    var maxlength = 25;
    var minLength = 10;
    switch (type) {
      case "otp":
        if (required(data)) {
          setErrOtp("otp cannot be left blank ");
          setError(true);
          return false;
        } else {
          setErrOtp(null);
          setError(false);
          setOtp(data);
        }
        break;

      case "password":
        if (required(data)) {
          setErrpassword("password cannot be left blank ");
          setError(true);
          return false;
        } else if (checkminlenght(data, minLength)) {
          setErrpassword(
            "password must have atleast " + minLength + " character",
          );
          setError(true);
          return false;
        } else if (checkmaxlenght(data, maxlength)) {
          setErrpassword(
            "password must be smaller than " + maxlength + " character",
          );
          setError(true);
          return false;
        } else if (!checkspecial(data)) {
          setErrpassword(
            "Please include at least one Special character in it(~`!@#$%^&*()+=|{}:;\"',<>.?\[\/\\\])",
          );
          setError(true);
          return false;
        } else if (!checkuppercase(data)) {
          setErrpassword(
            "Please include at least one Uppercase character in it",
          );
          setError(true);
          return false;
        } else if (!checklowercase(data)) {
          setErrpassword(
            "Please include at least one Lowercase character in it",
          );
          setError(true);
          return false;
        } else if (!checknumber(data)) {
          setErrpassword("Please include at least one Numeric");
          setError(true);
          return false;
        } else {
          setErrpassword(null);
          setError(false);
          setPassword(data);
        }
        break;
      case "confirmpassword":
        if (required(data)) {
          setcnfpassworderr("password cannot be left blank ");
          setError(true);
          return false;
        }
        if (data != password) {
          setcnfpassworderr("password and confirm password do not match");
          setError(true);
          return false;
        } else {
          setcnfpassworderr(null);
          setError(false);
        }
        break;
      default:
    }
    return true;
  }

  function setPasswordtype() {
    if (passwordtype == "password") {
      setpasswordtype("text");
    } else {
      setpasswordtype("password");
    }
  }
  function setcnfPasswordtype() {
    if (cnfpasswordtype == "password") {
      setcnfpasswordtype("text");
    } else {
      setcnfpasswordtype("password");
    }
  }
  return (
    <>
      <div className="container-fluid p-0 pe-0">
        <div className="row">
          <div>
            <Navbarp />
          </div>
          <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{ minHeight: "calc(100vh - 70px)" }}
          >
            <h3 className="ms-3" style={{ marginTop: "25" }}>
              Reset Password
            </h3>
            {message ? (
              <span className="text-danger">
                {message}
                {countdown !== null && countdown > 0 && (
                  <> Redirecting to login in {countdown} seconds...</>
                )}
              </span>
            ) : (
              <div>
                <Form className="m-4" onSubmit={handleSubmit}>
                  <Form.Group className="mt-3" controlId="formBasicPassword">
                    <Form.Label>Enter OTP to change the password</Form.Label>
                    <InputGroup className="mt-1">
                      <Form.Control
                        type={Number}
                        placeholder="Enter your Otp to change the  password"
                        name=""
                        onChange={(e) => {
                          validate(e.target.value, "otp");
                        }}
                        onBlur={(e) => {
                          validate(e.target.value, "otp");
                        }}
                      />
                    </InputGroup>
                    <Form.Text className="text-muted">
                      {errOtp ? (
                        <span className="text-danger">{errOtp}</span>
                      ) : null}{" "}
                      .<br />
                    </Form.Text>
                  </Form.Group>
                  <Form.Group className="mt-3" controlId="formBasicPassword">
                    <Form.Label>Enter New password</Form.Label>
                    <InputGroup className="mt-1">
                      <Form.Control
                        type={passwordtype}
                        onChange={(e) => {
                          validate(e.target.value, "password");
                        }}
                        onBlur={(e) => {
                          validate(e.target.value, "password");
                        }}
                        placeholder="Please enter new password"
                      />
                      <Button
                        variant="outline-primary"
                        onClick={setPasswordtype}
                      >
                        {passwordtype === "password" ? (
                          <i className="bi bi-eye-slash"></i>
                        ) : (
                          <i className="bi bi-eye"></i>
                        )}
                      </Button>
                    </InputGroup>
                    <Form.Text className="text-muted">
                      The password should contain atleast one small and upper
                      case character, a number and a special character <br />
                      {Errpassword ? (
                        <span className="text-danger">{Errpassword}</span>
                      ) : null}
                    </Form.Text>
                  </Form.Group>
                  <Form.Group className="mt-3" controlId="formBasicPassword">
                    <Form.Label>Confirm New password</Form.Label>
                    <InputGroup className="mt-1">
                      <Form.Control
                        type={cnfpasswordtype}
                        onChange={(e) => {
                          validate(e.target.value, "confirmpassword");
                        }}
                        onBlur={(e) => {
                          validate(e.target.value, "confirmpassword");
                        }}
                        placeholder="Please re enter the new password"
                      />
                      <Button
                        variant="outline-primary"
                        onClick={setcnfPasswordtype}
                      >
                        {cnfpasswordtype === "password" ? (
                          <i className="bi bi-eye-slash"></i>
                        ) : (
                          <i className="bi bi-eye"></i>
                        )}
                      </Button>
                    </InputGroup>
                    {cnfpassworderr ? (
                      <span className="text-danger">{cnfpassworderr}</span>
                    ) : null}
                  </Form.Group>
                  <div className="d-flex flex-column align-items-center mt-5">
                    {errorMessage && (
                      <span className="text-danger mb-3">{errorMessage}</span>
                    )}

                    <Button
                      variant="warning"
                      type="submit"
                      size="lg"
                      disabled={error}
                    >
                      {loading ? (
                        <SmallLoader loadingtext={"Submitting..."} />
                      ) : (
                        "Submit"
                      )}
                    </Button>
                  </div>
                </Form>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;
